<template>
  <div class="recharge-container">
    <header class="recharge-header">
      <img src="@/assets/back.png" alt="" class="back-img" @click="goBack">
      <h1></h1>
    </header>
    <main class="recharge-content">
      <div class="recharge-content-top">
        <img src="@/assets/pay.png" alt="">
      </div>
      <div class="recharge-content-bottom">
        <div class="countdown-container">
          <div v-if="errorMessage">
            <img src="@/assets/error.png" alt="">
            <p>{{ errorMessage }}</p>
          </div>
          <div v-else>
            <img src="@/assets/load.png" class="loading-img" alt="">
            <p>正在处理中...</p>
          </div>
        </div>
        <div class="recharge-content-info">
          <div class="title">订单信息</div>
          <p class="recharge-content-p" v-if="id"><span>订单ID: </span>{{ id }}</p>
          <p class="recharge-content-p" v-if="urlAmount"><span>金额: </span>{{ urlAmount }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import md5 from 'js-md5';

export default {
  name: 'AmountInputAnyAuto',
  data() {
    return {
      // 参数相关
      gameid: null,
      id: null,
      urlAmount: null,
      payChannelId: null,
      buyerName: '',
      buyerNameisRequired: false,
      
      // 状态相关
      isLoading: true,
      isSuccess: false,
      errorMessage: '',
      errorDetails: '',
      
      // 提交状态
      isSubmitting: false,
      hasSubmitted: false
    };
  },
  async mounted() {
    // 设置body样式
    document.body.style.margin = '0 auto';
    
    try {
      // 1. 获取URL参数
      await this.extractUrlParams();
      
      // 2. 验证必要参数
      this.validateRequiredParams();
      
      // 3. 自动触发提交
      await this.autoSubmit();
      
    } catch (error) {
      this.handleError('参数处理失败', error.message);
    }
  },
  beforeDestroy() {
    // 清理body样式
    document.body.style.margin = '';
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 提取URL参数
    extractUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      
      this.gameid = urlParams.get('gameid');
      this.id = urlParams.get('id');
      this.urlAmount = urlParams.get('amount');
      this.payChannelId = urlParams.get('paychannelid');
      
      // 记录获取的参数
      console.log('URL参数获取结果:', {
        gameid: this.gameid,
        id: this.id,
        urlAmount: this.urlAmount,
        payChannelId: this.payChannelId
      });
    },
    
    // 验证必要参数
    validateRequiredParams() {
      const missingParams = [];
      
      if (!this.gameid) missingParams.push('gameid');
      if (!this.id) missingParams.push('id');
      if (!this.urlAmount) missingParams.push('amount');
      
      if (missingParams.length > 0) {
        throw new Error(`缺少必要参数: ${missingParams.join(', ')}`);
      }
      
      // 验证金额格式
      const amount = parseInt(this.urlAmount);
      if (isNaN(amount)) {
        throw new Error('金额参数格式无效');
      }
      
      // 根据gameid验证金额范围
      if (this.gameid === '2') {
        if (amount < 10 || amount >= 2000) {
          throw new Error('金额必须为大于等于10小于2000的整数');
        }
      } else {
        if (amount < 1 || amount >= 3001) {
          throw new Error('金额必须为大于等于1小于等于3000的整数');
        }
      }
      
      // 设置buyerNameisRequired逻辑（根据原页面逻辑）
      this.buyerNameisRequired = false; // 根据原页面，这个页面不需要购买者姓名
      this.buyerName = '空'; // 设置默认值
    },
    
    // 自动提交
    async autoSubmit() {
      // 防止重复提交
      if (this.hasSubmitted || this.isSubmitting) {
        return;
      }
      
      this.isSubmitting = true;
      this.errorMessage = '';
      this.errorDetails = '';
      
      try {
        await this.submitAmount();
        this.hasSubmitted = true;
      } finally {
        this.isSubmitting = false;
      }
    },
    
    // 提交金额（基于原页面的submitAmount方法）
    async submitAmount() {
      try {
        const key = process.env.VUE_APP_API_KEY;
        const timestamp = new Date().getTime();
        const token = md5(timestamp + key);
        
        // 判断是否为本机地址
        const originUrl = 'http://localhost:5053';
        const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);
        const PayUrl = isLocal 
          ? `${originUrl}/api2/Pay3` 
          : `${window.location.origin}/api2/Pay3`;

     
        const response = await axios.post(PayUrl, {
          amount: this.urlAmount,
          id: this.id,
          token: token,
          gameid: this.gameid,
          payChannelId: this.payChannelId,
          timestamp: timestamp,
          buyerName: this.buyerName,
        });
        
        console.log('创建订单响应:', response.data);
        const payUrl = response.data.data.payurl;
        
        if (payUrl) {
          this.isSuccess = true;
          this.isLoading = false;
          
          // 延迟跳转，让用户看到成功提示
          setTimeout(() => {
            window.location.href = payUrl;
          }, 0);
        } else {
          throw new Error('未获取到有效的支付链接');
        }
        
      } catch (error) {
        // 根据错误类型提供更详细的错误信息
        let errorMsg = '创建订单失败';
        if (error.response) {
          // 服务器响应错误
          errorMsg = `服务器错误: ${error.response.status}`;
          if (error.response.data && error.response.data.message) {
            errorMsg += ` - ${error.response.data.message}`;
          }
        } else if (error.request) {
          // 请求发送但无响应
          errorMsg = '网络连接失败，请检查网络设置';
        } else {
          // 其他错误
          errorMsg = error.message;
        }
        
        throw new Error(errorMsg);
      }
    },
    
    // 错误处理
    handleError(message, details = '') {
      this.isLoading = false;
      this.errorMessage = message;
      this.errorDetails = details;
      
      console.error('处理错误:', message, details);
    }
  }
};
</script>

<style scoped>
.back-img{
  width: 20px;
  height: 20px;
  position: absolute;
  left: 10px;
  top: 10px;
}
.red-color{
  color: #ff1a1a;
  font-weight: 700;
  margin:0 2px;
}
.loading-img{
  width: 2rem;
  height: 2rem;
  animation: rotate 2s linear infinite; 
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.recharge-container {
  max-width: 640px;
  margin: 0 auto;
  background:#f7f7f7 ;
  height: 100vh;
}

.recharge-header {
  position: relative;
  text-align: center;
  width: 100%;
  height: 44px;
  color: #fff;
  background:#3F9FFF;
}

.recharge-header h1 {
  color: #fff; 
  font-size: 1rem;
  line-height: 44px;
}
.recharge-content {

}
.recharge-content-top {
  background: #3F9FFF;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
@keyframes breathing {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.recharge-content-top img {
  width: 14rem;
  height: auto;
  animation: breathing 2s infinite;
}

.recharge-content-bottom{
  width: calc(100% - 2rem);
  box-shadow: 0px 3px 6px 0px #232B321A;
  background: #fff;
  margin: 0 auto;
  border-radius: 16px;
  position: relative;
  top: -1rem;
  padding: 1rem;
  text-align: left;
}
.recharge-content-info{
  margin:1rem;
}
.recharge-content-info .title{
  color: #333; 
  font-size: 0.9rem;
  margin-bottom: 10px;
  line-height: 1.6;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.recharge-content-info .title::before{
  content: '';
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #3F9FFF;
  margin-right: 0.5rem;
  border-radius: 0.5rem;
}
.recharge-content-p {
  color: #333; 
  font-size: 0.9rem;
  margin-bottom: 10px;
  line-height: 1.6;
}
.recharge-content-p span{
  display: inline-block;
  color: #666; 
  font-size: 0.9rem;
  margin-right: 0.5rem;
  width: 4rem;
  font-weight: 500;
}
.countdown-container>div{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}
.countdown-container p{
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}
.countdown-container img{
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;
}
.recharge-content p:last-child {
  margin-bottom: 0;
}
</style>